import React, { useEffect, useState } from 'react';
import { logger } from '@/lib/logger';

interface SafariImageFixProps {
  children: React.ReactNode;
}

export function SafariImageFix({ children }: SafariImageFixProps) {
  const [isSafari, setIsSafari] = useState(false);
  
  useEffect(() => {
    // Detect Safari/iOS
    const ua = navigator.userAgent;
    const safari = /^((?!chrome|android).)*safari/i.test(ua);
    const ios = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
    
    if (safari || ios) {
      setIsSafari(true);
      
      // Add Safari-specific fixes
      // Fix for cross-origin image loading issues
      const meta = document.createElement('meta');
      meta.httpEquiv = 'Cross-Origin-Embedder-Policy';
      meta.content = 'unsafe-none';
      document.head.appendChild(meta);
      
      // Log for debugging
      logger.log('[SafariImageFix] Applied Safari/iOS fixes');
      
      return () => {
        document.head.removeChild(meta);
      };
    }
  }, []);
  
  return <>{children}</>;
}
